import { render, staticRenderFns } from "./PanelWrapper.vue?vue&type=template&id=32a25d8c&scoped=true&"
import script from "./PanelWrapper.vue?vue&type=script&lang=js&"
export * from "./PanelWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PanelWrapper.vue?vue&type=style&index=0&id=32a25d8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a25d8c",
  null
  
)

export default component.exports